// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3T5B4","signatureButtonsRight":"ModalSign_signatureButtonsRight__1kYZf"};